import PropTypes from 'prop-types'

const Heading = ({ children }) => {
  return <h1 className="mb-2 auto-title">{children}</h1>
}

Heading.propTypes = {
  children: PropTypes.string,
}

export default Heading
